export default () => {
  apos.util.widgetPlayers['image-slider'] = {
    selector: '[data-image-slider-widget]',
    player(el) {
      const slides = el.querySelectorAll('.image-slider__slide');
      if (slides.length <= 1) {
        return;
      }

      const prevBtn = el.querySelector('.image-slider__arrow--prev');
      const nextBtn = el.querySelector('.image-slider__arrow--next');
      const autoplay = el.dataset.autoplay === 'true';
      const intervalMs = 5000;
      const transitionMs = 400;
      let currentIndex = 0;
      let intervalId = null;
      let isAnimating = false;

      function showSlide(index) {
        const nextIndex = (index + slides.length) % slides.length;
        if (isAnimating || nextIndex === currentIndex) {
          return;
        }

        isAnimating = true;
        slides[currentIndex].classList.remove('image-slider__slide--active');
        slides[currentIndex].setAttribute('aria-hidden', 'true');
        currentIndex = nextIndex;
        slides[currentIndex].classList.add('image-slider__slide--active');
        slides[currentIndex].removeAttribute('aria-hidden');

        setTimeout(() => {
          isAnimating = false;
        }, transitionMs);
      }

      function next() {
        showSlide(currentIndex + 1);
      }

      function prev() {
        showSlide(currentIndex - 1);
      }

      function stopAutoplay() {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }

      function startAutoplay() {
        stopAutoplay();
        if (autoplay) {
          intervalId = setInterval(next, intervalMs);
        }
      }

      prevBtn.addEventListener('click', () => {
        prev();
        startAutoplay();
      });

      nextBtn.addEventListener('click', () => {
        next();
        startAutoplay();
      });

      startAutoplay();
    }
  };
};
